import { YACHT_STATUS } from '@/shared/constants/yacht-status.constant';
import { convertTimezone } from '@/shared/lib/helpers/convert-timezone.helper';
import { dateFormat } from '@/shared/lib/helpers/date-format.helper';

import { Boat } from '../types/boat.interface';
import { BoatResponse } from '../types/boat-api.interface';

export const transformBoatResponse = (response: BoatResponse, timezone: string): Boat => ({
	country: response.country,
	name: response.name,
	description: response.description,
	boatType: response.boat_type,
	createdAt: dateFormat(convertTimezone(response.created_at, timezone)),
	updatedAt: dateFormat(convertTimezone(response.updated_at, timezone)),
	id: String(response.id),
	users: response.users.map((userId) => String(userId)),
	mmsi: response.mmsi,
	uuid: response.boat_uuid,
	plantAddress: response.plant_address,
	groupName: response.group_name,
	shipyardGroupId: response.shipyard_group_id,
	shipyardGroupName: response.shipyard_group_name,
	shipyardGroupPath: response.shipyard_group_path,
	status: response.status ?? YACHT_STATUS.InProduction,
	shipyardDeliveryDate: response?.shipyard_delivery_date
		? dateFormat(convertTimezone(response.shipyard_delivery_date, timezone), {
				format: 'shortMonthDate',
		  })
		: '',
	customerDeliveryDate: response?.customer_delivery_date
		? dateFormat(convertTimezone(response.customer_delivery_date, timezone), {
				format: 'shortMonthDate',
		  })
		: '',
});
